import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1d0b4838")

_pushScopeId("data-v-1d0b4838")
const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = { class: "grid gap-3 grid-cols-1 md:grid-cols-3 lg:grid-cols-4" }
const _hoisted_3 = { class: "border border-gray-lp-1300 rounded-lg row-span-1 md:row-span-6 lg:row-span-3" }
const _hoisted_4 = { class: "border border-gray-lp-1300 rounded-lg col-span-1 md:col-span-2 lg:col-span-3" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3" }
const _hoisted_6 = { class: "border border-gray-lp-1300 rounded-lg md:row-span-4 lg:row-span-2" }
const _hoisted_7 = { class: "border border-gray-lp-1300 rounded-lg lg:col-span-2" }
const _hoisted_8 = { class: "grid grid-cols-1 lg:grid-cols-2" }
const _hoisted_9 = { class: "border border-gray-lp-1300 rounded-lg lg:col-span-2" }
const _hoisted_10 = { class: "grid grid-cols-1 lg:grid-cols-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_DetailStatusSection = _resolveComponent("DetailStatusSection")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Title, { label: "Overall Summary" }),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DetailStatusSection, _mergeProps({
          class: "py-4 px-3",
          "data-testid": "cod-report-summary-total-amount"
        }, _ctx.statusDelSection), null, 16)
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DetailStatusSection, _mergeProps({
            class: "border-b md:border-r lg:border-b-0 border-gray-lp-1300 py-4 px-3",
            "swap-display": ""
          }, _ctx.podDexData('total')), null, 16),
          _createVNode(_component_DetailStatusSection, _mergeProps({
            class: "border-b md:border-r-none lg:border-b-0 border-gray-lp-1300 py-4 px-3",
            "swap-display": ""
          }, _ctx.podDexData('outstanding')), null, 16),
          _createVNode(_component_DetailStatusSection, _mergeProps({
            class: "border-none md:border-r lg:border-b-0 lg:border-none border-gray-lp-1300 py-4 px-3",
            "swap-display": ""
          }, _ctx.podDexData('collected')), null, 16)
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_DetailStatusSection, _mergeProps({
          class: "py-4 px-3",
          "swap-display": ""
        }, _ctx.codRejDexData('total')), null, 16)
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_DetailStatusSection, _mergeProps({
            class: "border-b md:border-r-none lg:border-b-0 border-gray-lp-1300 py-4 px-3",
            "swap-display": ""
          }, _ctx.codRejDexData('codrej')), null, 16),
          _createVNode(_component_DetailStatusSection, _mergeProps({
            class: "border-gray-lp-1300 py-4 px-3",
            "swap-display": ""
          }, _ctx.codRejDexData('collected-codrej')), null, 16)
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode(_component_DetailStatusSection, _mergeProps({
            class: "border-b md:border-r-none lg:border-b-0 border-gray-lp-1300 py-4 px-3",
            "swap-display": ""
          }, _ctx.codRejDexData('dex')), null, 16),
          _createVNode(_component_DetailStatusSection, _mergeProps({
            class: " border-gray-lp-1300 py-4 px-3",
            "swap-display": ""
          }, _ctx.codRejDexData('collected-dex')), null, 16)
        ])
      ])
    ])
  ]))
})